"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconLightClassName = exports.iconRegularClassName = exports.iconFilledClassName = void 0;
exports.iconFilledClassName = "fui-Icon-filled";
exports.iconRegularClassName = "fui-Icon-regular";
exports.iconLightClassName = "fui-Icon-light";